import { t } from 'i18next';

import { FilterField } from 'coreOld/enums';

export const filtersConfig = () => [
  {
    name: 'number',
    type: FilterField.SEARCH,
    flex: 100,
    props: {
      placeholder: t('labelPartNumber'),
    },
  },
];
